/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, {useContext, useEffect, useRef, useState} from "react";
import {DayPicker} from 'react-day-picker';
import {useHistory} from 'react-router-dom';
import {Field, Form, Formik} from 'formik';
import * as yup from 'yup';
import {Col, Row} from 'components/Grid';
import TagsList3 from "components/TagList3";
import {Label, InputField} from "components/Form";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import Button, {ButtonContainer} from 'components/Button';
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import {LostCancelButton} from 'components/index';
import {GlobalAuthContext, GlobalLoaderContext} from 'store/context';
import {FitinsurAPI, MessageCenter} from 'utils';
import StepNavigation from "components/StepNavigation/index";
import RenderButtons from 'components/RenderButtons';
import HasPermission from "components/HasPermission/index";
import ModalConfirmation from "components/ModalConfirmation/index";
import {GridColumnTitle} from "components/Form";
import {
  useHeaderNbi,
  useWordingHtmlModal,
  useGetSchedulleAssumptions,
  useGetDocumentsEndorsementContracts,
  useEndorsementSigners,
  useGetDocuments
} from "services/QuoteService";
import {useOperationInfo} from 'services/OperationService';
import {
  useGetQuestionnaireAnswer,
} from '@fitinsur/services/QuestionnaireAnswerService';
import {EndorsementTagList, FileModal} from '@fitinsur/components'

import {
  CalendarContainer,
  ButtonContent,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCollum,
  InlineLabel,
  LabelEdit,
} from './styles';

export default function SendApprovalPolicyPack(props) {
  const [file, setFile] = useState();
  const [canGeneratePack, setCanGeneratePack] = useState(false);
  const [summary, setSummary] = useState({});
  const [rejectDocuments, setRejectDocuments] = useState(false);
  const [scheduleAssumptionsFile, setScheduleAssumptionsFile] = useState({});
  const [wordingFile, setWordingFile] = useState({});
  const [endorsementFile, setEndorsementFile] = useState([]);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [historymsg, setHistorymsg] = useState([]);
  const [isBound, setIsBound] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [signers, setSigners] = useState([]);
  const [validation, setValidation] = useState({});
  const [selectedTypesEndorsement, setSelectedTypesEndorsement] = useState([])
  const [idDomainOperation, setIdDomainOperation] = useState(false);
  const [endorsementDocuments, setEndorsementDocuments] = useState([]);
  const [operation, setOperation] = useState(null);

  const authContext = useContext(GlobalAuthContext);
  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useWordingHtmlModalData,
    loading: useWordingHtmlModalLoading,
    error: useWordingHtmlModalError,
    status: useWordingHtmlModalStatus,
    request: useWordingHtmlModalRequest,
  } = useWordingHtmlModal(props.match.params.idOperation);

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    error: useGetDocumentsError,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest,
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useGetSchedulleAssumptionsData,
    loading: useGetSchedulleAssumptionsLoading,
    error: useGetSchedulleAssumptionsError,
    status: useGetSchedulleAssumptionsStatus,
    request: useGetSchedulleAssumptionsRequest,
  } = useGetSchedulleAssumptions(props.match.params.idOperation);

  const {
    data: useGetDocumentsEndorsementContractsData,
    loading: useGetDocumentsEndorsementContractsLoading,
    error: useGetDocumentsEndorsementContractsError,
    status: useGetDocumentsEndorsementContractsStatus,
    request: useGetDocumentsEndorsementContractsRequest,
  } = useGetDocumentsEndorsementContracts(props.match.params.idOperation);

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useEndorsementSignersData,
    loading: useEndorsementSignersLoading,
    error: useEndorsementSignersError,
    status: useEndorsementSignersStatus,
    request: useEndorsementSignersRequest,
  } = useEndorsementSigners(props.match.params.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  useEffect(() => {
    if (useHeaderNbiLoading || useWordingHtmlModalLoading || useGetDocumentsLoading || useGetSchedulleAssumptionsLoading || useGetDocumentsEndorsementContractsLoading
      || useOperationInfoLoading || useEndorsementSignersLoading || useGetQuestionnairesAnswersLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useWordingHtmlModalLoading, useGetDocumentsLoading, useGetSchedulleAssumptionsLoading, useGetDocumentsEndorsementContractsLoading,
    useOperationInfoLoading, useEndorsementSignersLoading, useGetQuestionnairesAnswersLoading]);


  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${new Date(message.approvalDate).toString()}
        ${message.approvalComments}
    `;
          tempmessage = (tempmessage + tempMsg);
        })
      return tempmessage;
    }
  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setSummary({
        typeOfCover: data.ret_value.typeOfCover,
        client: data.ret_value.client,
        obligorCoding: data.ret_value.obligorCoding,
        responseBy: data.ret_value.responseBy,
        internalContact: data.ret_value.internalContact,
        broker: data.ret_value.broker,
        dealCode: data.ret_value.deal,
        nmFacility: data.ret_value.nmFacility,
        nmObligor: data.ret_value.nmObligor,
        projectName: data.ret_value.projectName,
        idOperation: props.match.params.idOperation,
      });

      setHistorymsg(data.ret_value.historical);
      setEndorsmentType(data.ret_value.endorsmentType);
      handleGetModal(data.ret_value.endorsmentType);
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  const handleSendApproval = () => {
    if (endorsementTypesAllowed.includes(endorsmentType)) {
      if (!selectedTypesEndorsement.length) {
        mc.error('Please, select at least one reason!')
        loading.stop()
        return;
      }
    }

    let signersValues = signers.map((signer) => ({
      ...signer,
      facilities: signer.facilities.map(facility => ({
        ...facility,
        textTabValue: formik.current.values[`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`] || facility.textTabValue
      }))
    }));

    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingSendApproval(props.match.params.idOperation, formik.current.values.policyPackMessage, formik.current.values.effectiveDate, selectedTypesEndorsement, signersValues)
      .then(resp => resp.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        history.push(`/broking/approval-policy-pack/${props.match.params.idOperation}`);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSendApproval.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  function handleGetModal(endorsmentType) {
    useWordingHtmlModalRequest().then(({data: resp}) => {
      if (resp.ret_code === 200) {
        setFile(resp.ret_value.policePackReturnDocs
          .filter(document => {
            const isEndorsement = endorsmentType && endorsmentType !== 'declaration';

            if (!isEndorsement) return true;

            return isEndorsement && ![23, 272, 373, 399, 401, 450, 453, 397, 493, 367].includes(document.idDomain);
          })
          .map(document => ({
            idDocument: document.idDocument,
            idDomainDescription: document.idDomainDescription,
            idReport: document.idReport,
            idOperation: document.idOperation,
            reportToken: document.reportToken,
            url: document.url,
            fileName: document.documentMetadata.fileName
          })))
      } else {
        mc.error(resp.ret_msg_details);
      }
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleGetModal.name}\n` + error);
      console.error('fitPostReject - Error:', error);
    });
  };

  const handleEnable = () => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingAttachments(props.match.params.idOperation).then(x => x.json()).then(res => {
      if (res.ret_code != 200) {
        return;
      }
    });
  }

  async function handleOperationInfo() {
    useOperationInfoRequest().then(({data: response}) => {
      setIdDomainOperation(response?.idDomain);
      setOperation(response);
      setIsBound(response?.isBound);
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
      });
  }

  async function handleGetSigners() {
    useEndorsementSignersRequest().then(({data: response}) => {
      if (response.ret_code !== 200) {
        return;
      }

      const validationSchema = {};
      const signersFiltered = response.ret_value?.map(signer => ({
        ...signer,
        facilities: signer.facilities
          .map(facility => {
            if (facility.textTabValue) {
              formik.current?.setFieldValue(`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`, facility.textTabValue)
              validationSchema[`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`] = yup.string().required('* Required field').max(15, 'Limited to 15 caracters');
            }
            return facility;
          })
      }))

      buildValidation(validationSchema);
      setSigners(signersFiltered);
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetSigners.name}\n` + error);
      });
  }

  async function handleSchedulleAssumptions(includeSchedulle) {
    if (includeSchedulle?.idAnswerOption && includeSchedulle?.idAnswerOption == 7530) {
      useGetSchedulleAssumptionsRequest().then(({data: response}) => {
        if (response.ret_code !== 200) {
          return;
        }
        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setScheduleAssumptionsFile({
            dsTypeDocument: "Schedule Assumptions",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return;
      }).catch((error) => {
        // mc.error(`There was an error while fetching your data: ${fitinsur.requestAttachAssumptions.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
    }
  }

  async function handleGetFiles() {
    useGetDocumentsRequest().then(({data: response}) => {
      if (response.ret_code !== 200) {
        return;
      }

      if (response.ret_value.length > 0) {
        const file = response.ret_value[0];
        setWordingFile({
          dsTypeDocument: file.dsTypeDocument || "Wording",
          nameDocument: file.nameDocument,
          idTypeDocument: file.idTypeDocument,
          nameFile: file.nameFile,
          size: file.size,
          type: file.type,
          urlLink: file.urlLink,
          idDocument: file.idDocument
        });
      }
      return response.ret_value;
    }).catch((error) => {
      // mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
      console.error('fitPostFiles - Error:', error);
    });

    useGetDocumentsEndorsementContractsRequest().then(({data: response}) => {
      if (response.ret_code !== 200) {
        mc.error(response.ret_msg_details);
        return;
      }

      const files = response.ret_value;
      let aux = [];

      files.forEach(file => {
        let obj = {
          dsTypeDocument: "Endorsement Contract",
          nameDocument: file.nameDocument,
          idTypeDocument: file.idTypeDocument,
          nameFile: file.nameFile,
          size: file.size,
          type: file.type,
          urlLink: file.urlLink,
          idDocument: file.idDocument
        };
        aux.push(obj);
      });
      setEndorsementFile(aux);
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${fitinsur.requestGetDocumentsEndorsementContracts.name}\n` + error);
      console.error('fitPostFiles - Error:', error);
    });

  }

  async function handleUpdateEffectiveDate(date, markedYes) {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateEndorsementEffectiveDate(props.match.params.idOperation, date, markedYes)
      .then(response => response.json())
      .then(response => {
        if (response.ret_code === 200) {
          const isPaymentEndorsement = endorsmentType === 'adjustments-and-corrections' || endorsmentType === 'client-change' || endorsmentType === 'off-risk' || endorsmentType === 'pre-agreed' || endorsmentType === 'policy-extension';

          setFile(null)
          handleGetModal();
          setCanGeneratePack(response.ret_value.canGeneratePack)

          if (!response.ret_value.canGeneratePack) {
            if (isPaymentEndorsement) {
              setShowAlertModal(true);
            } else {
              mc.error('Effective date not between Policy Inception date and Policy Expiry date');
            }
          }
        } else {
          mc.error(response.ret_msg_details);
        }
      })
      .catch((error) => {
        mc.error("There was an error while updating endersment date: \n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }


  async function handleUpdateEndersementReport(property, value) {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateEndersementReport(props.match.params.idOperation, property, value)
      .then(response => response.json())
      .then(response => {
        if (response.ret_code === 200) {
          setFile(null)
          handleGetModal();
          loading.stop();
        } else {
          mc.error(response.ret_msg_details);
          loading.stop();
        }
      })
      .catch((error) => {
        loading.stop();
        mc.error("There was an error while updating endersment date: \n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  const handleEndorsementDocuments = (data) => {
    let questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks,
      ...data.mrc,
    ];

    const endorsementDocumentsQst = questionnaire.find((qst) => qst.idQuestion === 1867)
    const includeSchedulle = questionnaire.find((qst) => qst.idQuestion === 1870)

    handleSchedulleAssumptions(includeSchedulle)

    if (endorsementDocumentsQst?.answer) {
      const documents = JSON.parse(endorsementDocumentsQst.answer) || []
      setEndorsementDocuments(documents)
    }
  }

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleEndorsementDocuments(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
    handleSummary();
    handleEnable();
    handleGetFiles();
    handleOperationInfo();
    buildValidation();
  }, [])

  useEffect(() => {

  }, [endorsmentType])

  useEffect(() => {
    if (endorsmentType === 'adjustments-and-corrections' || endorsmentType === 'client-change') {
      handleGetSigners();
    }
    if (endorsmentType !== '') {
      useGetQuestionnairesAnswersRequest();
    }
  }, [endorsmentType])

  const endorsmentTypeEnum = {
    ['not-pre-agreed']: {
      title: 'Anniversary - Premium: Not Pre Agreed / Endorsement Pack Approval'
    },
    ['cancellation']: {
      title: 'Endorsement - Cancellation / Endorsement Pack Approval'
    }
  }

  const buildValidation = (extraValidation = {}) => {
    const validationSchema = {
      policyPackMessage: yup.string().required("* Required field"),
      effectiveDate: endorsmentType ? yup.string().required('* Required field') : yup.string().nullable(),
      ...extraValidation,
    }

    setValidation(yup.object().shape(validationSchema))
  }

  const SubmitButton = () => {
    if (!endorsmentType && rejectDocuments) {
      return (
        <HasPermission permission={props.permissions.GENERATE_WORDING}>
          <Button
            style={{marginLeft: "10px", marginTop: "5px"}}
            primary
            type="submit"
            id="btnSubmit"
            onClick={() => {
              history.go('/list');
            }}
          >
            GENERATE WORDING
          </Button>
        </HasPermission>
      )
    }

    if ((!canGeneratePack || !endorsmentType) && !rejectDocuments) {
      const operation = idDomainOperation && (idDomainOperation === 253 || idDomainOperation === 254 || idDomainOperation === 624 || idDomainOperation === 395);
      return (
        <HasPermission
          permission={props.permissions.POLICY_PACK_SEND_INTERNALLY || (endorsmentType && props.permissions.ENDORSEMENT_PACK_SEND_INTERNALLY)}>
          <Button
            style={{marginLeft: "10px", marginTop: "5px"}}
            primary
            type="submit"
            id="btnSubmit"
            onClick={() => operation ? history.push(`/broking/stamp-request-contacts/${props.match.params.idOperation}`) : history.push(`/broking/send-order-to-bind/${props.match.params.idOperation}`)}
          >
            {operation ? 'STAMPS' : 'ORDER TO BIND'}
          </Button>
        </HasPermission>
      )
    }

    return <div/>
  }

  const renderUWReferenceByInsurer = (formikProps) => {
    if (!signers.length) return <div/>

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>
              <GridColumnTitle>
                Insurer Name
              </GridColumnTitle>
            </TableHeader>
            <TableHeader>
              <GridColumnTitle>
                UW Reference
              </GridColumnTitle>
            </TableHeader>
          </TableRow>
        </TableHead>

        <TableBody>
          {signers.map((signer, index) => (
            <TableRow>
              <TableCollum>
                <InlineLabel>
                  Insurer Name
                </InlineLabel>
                <LabelEdit>
                  {signer?.party}
                </LabelEdit>
              </TableCollum>

              <TableRow>
                <TableCollum style={{width: 400}}>
                  {signer.facilities.map((facility, index) => {
                    if (facility.textTabValue) {
                      return (
                        <>
                          <InlineLabel>
                            Facility
                          </InlineLabel>
                          <LabelEdit>
                            {facility?.name}
                          </LabelEdit>

                          <Field
                            style={{minWidth: 100}}
                            name={`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`}
                            value={formikProps.values?.[`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`]}
                            onChange={(e) => formikProps?.setFieldValue(`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`, e)}
                            component={InputField}
                            onBlur={async () => {

                              if (formikProps.errors[`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`]) {
                                mc.error('Please fill the field correctly')
                                return;
                              }

                              let signersValues = signers.map((signer) => ({
                                ...signer,
                                facilities: signer.facilities.map(facility => ({
                                  ...facility,
                                  textTabValue: formik.current.values[`reference_number_${signer.idPerson}_${facility.idQuestionnaireAnswer}`] || facility.textTabValue
                                }))
                              }));

                              handleUpdateEndersementReport('signers', signersValues);

                            }}
                          />
                        </>
                      )
                    }
                  })}
                </TableCollum>
              </TableRow>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  const endorsementTypesAllowed = [
    'pre-agreed', 'not-pre-agreed',
    'adjustments-and-corrections', 'market-changes',
    'cancellation', 'off-risk', 'policy-extension',
    'client-change'
  ];

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation}/>
      <BrokingSummary data={summary}/>
      <ContentCard
        title={endorsmentTypeEnum[endorsmentType] ? endorsmentTypeEnum[endorsmentType].title : endorsmentType ? "Endorsement Pack" : "Policy Pack"}
        icon info={{
        idOperation: props.match?.params?.idOperation || null,
        idProduct: props.location?.state?.idProduct || null
      }}>
        <Formik
          innerRef={formik}
          initialValues={{
            dealAnalisysInformation: '',
            policyPackMessage: '',
            effectiveDate: '',
          }}
          validationSchema={validation}
          onSubmit={() => handleSendApproval()}
        >
          {formikProps => (
            <Form>
              <FileModal idOperation={props?.match?.params?.idOperation} documents={file} />

              <HasPermission
                permission={![26, 27].includes(operation?.idDomain) || endorsmentType === 'market-changes'}>
                {(wordingFile && wordingFile.nameFile || scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile && (!endorsmentType || endorsmentType === '')) ?
                  <Col md={endorsmentType !== '' ? 8 : 9} sm={1} style={{marginBottom: 20}}>
                    <Label fontSize='16px'>Attachments</Label>
                    <TagsList3
                      tags={[wordingFile, scheduleAssumptionsFile].filter(file => file.nameFile)}
                      disableType
                      hideTrash
                      isEndorsement={false}
                    />
                  </Col>
                  : ''}

                <br/>

                <EndorsementTagList
                  tags={endorsementDocuments}
                  showRemoveIcon={false}
                  attachments={wordingFile && wordingFile.nameFile || scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile ? [wordingFile, scheduleAssumptionsFile].filter(file => file.nameFile) : []}
                />
              </HasPermission>

              {rejectDocuments ?
                <Field
                  readOnly
                  label={'Deal Analysis Information'}
                  name={'dealAnalisysInformation'}
                  value={handleHistoryMessage()}
                  onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                  component={TextField}
                />
                : ''}
              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <HasPermission permission={!isBound}>
                  <RenderButtons idOperation={props.match?.params?.idOperation}>
                    <ButtonContent>
                      <div style={{marginTop: "5px"}}>
                        <LostCancelButton idOperation={props.match?.params?.idOperation}/>
                      </div>

                      <Button third style={{marginLeft: "10px", marginTop: "5px"}}
                              onClick={() => history.push(`/broking/market-composition/${props.match.params.idOperation}`)}>
                        CDR
                      </Button>

                      <SubmitButton/>
                    </ButtonContent>
                  </RenderButtons>
                </HasPermission>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen/>)}
    </Layout>
  );
}